import React from 'react'
import {
    Box,
    Popover,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Collapse,
    Divider,
    Backdrop,
    Tooltip,
} from "@mui/material";
import {
    Dashboard,
    ManageAccounts,
    Person,
    Logout,
    ExpandMore,
    AccessTime,
    StarBorderRounded,
    LocalOfferOutlined,
    AccountBalanceWalletOutlined,
} from "@mui/icons-material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import manageicon from "assests/restaurant_menu_24dp_E8EAED 2.svg";
import customersIcon from "assests/groups_24dp_E8EAED 2.svg";
import ordersIcon from "assests/food_bank_24dp_E8EAED 1.svg";
import defaultImg from "assests/Serve-link-default.png";
import "./menudrawer.css";
import ConfirmationDialog from "components/Modal/ConfirmationDialog/ConfirmationDialog";
import { useSelector } from 'react-redux';
import { getOrderTypePermissions, isPermissionAllowed } from 'utils/function';

const RestaurantMenuPopupContainer = ({
    anchorEl,
    open,
    onClose,
    restaurantName,
    restaurantDescription,
    logoSrc,
    handleOrderRelatedClick,
    handleManageMenuClick,
    handleConfirmLogout,
    handleCloseConfirm,
    handleLogoutClick,
    manageMenuOpen,
    openLogoutConfirm,
    orderRelatedOpen,
    isLoggingOut,
    handleClickItem
}) => {
    const loginUserData = useSelector((state) => state?.posData)
    const permissions = React.useMemo(() => getOrderTypePermissions(loginUserData), [loginUserData]);
    const isCollectionPointAllowed = isPermissionAllowed(permissions, 'permission_collection_point');
    const isTableBookingAllowed = isPermissionAllowed(permissions, 'permission_table_booking');
    return (
        <>
            <Backdrop
                open={open}
                sx={{
                    zIndex: (theme) => theme.zIndex.drawer - 1, // One less than the Popover
                    // backgroundColor: "rgba(0, 0, 0, 0.3)",
                }}
                onClick={() => {
                    // Prevent backdrop from closing the popover if logout dialog is active
                    if (!openLogoutConfirm) {
                        onClose();
                    }
                }}
            />
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={onClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                className="responsiveMargin"
                PaperProps={{
                    sx: {
                        maxHeight: "calc(100% - 65px)",
                        width: { xs: "100%", sm: 320 },
                    },
                    className: "custom-popover-paper"
                }}
            >
                <Box className="menuHeader">
                    <Box className='menu-drawer-main-container'>
                        <Box className='menu-drawer-logo'>
                            <img
                                src={
                                    logoSrc
                                        ? `${process.env.REACT_APP_API_ROUTE}/files/${logoSrc}`
                                        : defaultImg
                                }
                                alt={restaurantName}
                                className={"logoImage"}
                            />
                        </Box>
                        <Box>
                            {/* <Typography className='res-name'>
                                {restaurantName}
                            </Typography>
                            <Typography color="black" sx={{ fontSize: "16px" }}>
                                {restaurantDescription}
                            </Typography> */}
                            <Tooltip title={restaurantName} arrow>
                                <Typography
                                    className="res-name"
                                    noWrap
                                    sx={{
                                        maxWidth: "200px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}
                                >
                                    {restaurantName}
                                </Typography>
                            </Tooltip>

                            <Tooltip title={restaurantDescription} arrow>
                                <Typography
                                    sx={{
                                        fontSize: "14px",
                                        maxWidth: "200px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap"
                                    }}
                                >
                                    {restaurantDescription}
                                </Typography>
                            </Tooltip>
                        </Box>
                    </Box>
                </Box>
                <Divider className='divider-menu-item' />

                <List component="nav" className='list-item-drawer'>
                    <ListItem button className='cursor-pointer' onClick={() => handleClickItem('dashboard')}>
                        <ListItemIcon className='list-item-icon-drawer'>
                            <Dashboard fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            className='list-item-text'
                            primary="Dashboard"
                        />
                    </ListItem>
                    <Divider className='divider-menu-item' />
                    {/* Manage Menu Accordion */}
                    <ListItem className='cursor-pointer' button onClick={handleManageMenuClick}>
                        <img
                            src={manageicon}
                            alt={"order"}
                            className='list-item-icon-image'
                        />
                        <ListItemText
                            primary="Manage Menu"
                            className='manage-item'
                        />
                        {manageMenuOpen ? <ExpandMore /> : <KeyboardArrowRightIcon />}
                    </ListItem>
                    <Divider className='divider-menu-item' />
                    <Collapse in={manageMenuOpen} timeout="auto" unmountOnExit>
                        <List className='cursor-pointer' component="div" disablePadding>
                            <ListItem className='cursor-pointer' button onClick={() => handleClickItem('categories')}>
                                <ListItemIcon></ListItemIcon>
                                <ListItemText
                                    className='list-sub-item-icon-drawer'
                                    primary="Food Categories"
                                />
                            </ListItem>
                            <Divider style={{ marginLeft: "47px", width: "249px" }} />
                            <ListItem button onClick={() => handleClickItem('food-items')}>
                                <ListItemIcon></ListItemIcon>
                                <ListItemText
                                    className='list-sub-item-icon-drawer'
                                    primary="Food Items"
                                />
                            </ListItem>
                            <Divider className='divider-menu-item' />
                        </List>
                    </Collapse>

                    {/* Order Related Accordion */}
                    <ListItem className='cursor-pointer' button onClick={handleOrderRelatedClick}>
                        <img
                            src={ordersIcon}
                            alt={"order"}
                            className='list-item-icon-image'
                        />
                        <ListItemText
                            primary="Order Related"
                            className='manage-item'
                        />
                        {orderRelatedOpen ? <ExpandMore /> : <KeyboardArrowRightIcon />}
                    </ListItem>
                    {/* <Divider sx={{marginX:'8px'}} /> */}
                    <Collapse in={orderRelatedOpen} timeout="auto" unmountOnExit>
                        <List className='cursor-pointer' component="div" disablePadding>
                            {isCollectionPointAllowed && (
                                <>
                                    <ListItem button onClick={() => handleClickItem('collection-point')}>
                                        <ListItemIcon>
                                            {/* <LocationOn fontSize="small" /> */}
                                        </ListItemIcon>
                                        <ListItemText
                                            className='list-sub-item-icon-drawer'
                                            primary="Collection Points"
                                        />
                                    </ListItem>
                                    <Divider style={{ marginLeft: "47px", width: "249px" }} />
                                </>
                            )}
                            {isTableBookingAllowed && (
                                <>
                                    <ListItem button onClick={() => handleClickItem('time-slots')}>
                                        <ListItemIcon>
                                            {/* <AccessTime  fontSize="small" /> */}
                                        </ListItemIcon>
                                        <ListItemText
                                            className='list-sub-item-icon-drawer'
                                            primary="Time Slots & Discounts"
                                        />
                                    </ListItem>
                                    <Divider style={{ marginLeft: "47px", width: "249px" }} />
                                </>
                            )}
                            <ListItem button onClick={() => handleClickItem('stations')}>
                                <ListItemIcon>
                                    {/* <AccessTime  fontSize="small" /> */}
                                </ListItemIcon>
                                <ListItemText
                                    className='list-sub-item-icon-drawer'
                                    primary="Stations"
                                />
                            </ListItem>
                        </List>
                    </Collapse>
                    {loginUserData?.role == "vendor" &&
                        <>
                            <Divider className='divider-menu-item' />
                            <ListItem className='cursor-pointer' button onClick={() => handleClickItem('manage-accounts')}>
                                <ListItemIcon className='list-item-icon-drawer'>
                                    <ManageAccounts fontSize="small" />
                                </ListItemIcon>
                                <ListItemText
                                    className='list-item-text'
                                    primary="Manage Accounts"
                                />
                            </ListItem>
                        </>
                    }
                    <Divider className='divider-menu-item' />
                    <ListItem className='cursor-pointer' button onClick={() => handleClickItem('customers')}>
                        <img
                            src={customersIcon}
                            alt={"order"}
                            className='list-item-icon-image'
                        />
                        <ListItemText
                            primary="Customers"
                            className='manage-item'
                        />
                    </ListItem>
                    <Divider className='divider-menu-item' />
                    <ListItem className='cursor-pointer' button onClick={() => handleClickItem('profile')}>
                        <ListItemIcon className='list-item-icon-drawer'>
                            <Person fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            className='list-item-text'
                            primary="My Profile"
                        />
                    </ListItem>
                    <Divider className='divider-menu-item' />
                    <ListItem className='cursor-pointer' button onClick={() => handleClickItem('manage-photos')}>
                        <ListItemIcon className='list-item-icon-drawer'>
                            <CameraAltIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            className='list-item-text'
                            primary="Manage Photos"
                        />
                    </ListItem>
                    <Divider className='divider-menu-item' />
                    <ListItem className='cursor-pointer' button onClick={() => handleClickItem('restaurant-timings')}>
                        <ListItemIcon className='list-item-icon-drawer'>
                            <AccessTime fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            className='list-item-text'
                            primary="Restaurant Timings"
                        />
                    </ListItem>
                    {/* <Divider className='divider-menu-item' />
                    <ListItem className='cursor-pointer' button onClick={() => handleClickItem('manage-reviews')}>
                        <ListItemIcon className='list-item-icon-drawer'>
                            <StarBorderRounded fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            className='list-item-text'
                            primary="Manage Reviews"
                        />
                    </ListItem> */}
                    <Divider className='divider-menu-item' />
                    <ListItem className='cursor-pointer' button onClick={() => handleClickItem('offers')}>
                        <ListItemIcon className='list-item-icon-drawer'>
                            <LocalOfferOutlined fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            className='list-item-text'
                            primary="Offers & Promo Codes"
                        />
                    </ListItem>
                    <Divider className='divider-menu-item' />
                    <ListItem className='cursor-pointer' button onClick={() => handleClickItem('cash-management')}>
                        <ListItemIcon className='list-item-icon-drawer'>
                            <AccountBalanceWalletOutlined fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            className='list-item-text'
                            primary="Cash Management"
                        />
                    </ListItem>
                    <Divider className='divider-menu-item' />
                    <ListItem
                        button
                        onClick={handleLogoutClick}
                        sx={{
                            cursor: "pointer",
                            "& .MuiSvgIcon-root": {
                                fontSize: 16,
                            },
                        }}
                    >
                        <ListItemIcon className='list-item-icon-drawer' sx={{ marginLeft: "3px", marginRight: "-32px !important" }}>
                            <Logout fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            className='list-item-text'
                            primary="Logout"
                        />
                    </ListItem>

                    <Divider className='divider-menu-item' />
                </List>

                <Box className='menu-drawer-fotter'>
                    <Typography variant="body2" color="text.secondary">
                        Having issue?
                    </Typography>
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="flex-center"
                        width="100%"
                    >
                        <Typography
                            color="primary"
                            className='support-ticket-text'
                            onClick={() => {
                                handleClickItem('support-tickets');
                                onClose?.();
                            }}
                            sx={{ cursor: 'pointer' }}
                        >
                            Create Support Ticket
                        </Typography>

                        <Typography variant="caption" color="text.secondary">
                            <span className='terms-usage'>
                                Terms of Usage
                            </span>{" "}
                            and{" "}
                            <span className='terms-usage'>
                                Privacy Policy
                            </span>
                        </Typography>
                    </Box>
                </Box>
            </Popover>
            <ConfirmationDialog
                open={openLogoutConfirm}
                handleClose={handleCloseConfirm}
                handleConfirm={handleConfirmLogout}
                isLoading={isLoggingOut}
                action="Logout"
                btnText="Logout"
                infoText="Are you sure you want to log out?"
            />
        </>
    )
}

export default RestaurantMenuPopupContainer
